import Util from '@/lib/util'
export default [
    {
        title:Util.L('Aging'),
        width:100,
        fixed:'left',
        key:'dayNum',
        render: (h: any, params: any) => {
            return h("span", "N+"+params.row.dayNum);
        }
  },{
        title:Util.L('SOStatusNEW'),
        width:100,
        key:'new',
        align: "right"
  },{
        title:Util.L('SOStatusPROCESSING'),
        width:100,
        key:'processing',
        align: "right"
  },{
        title:Util.L('SOStatusRT_PICK'),
        width:100,
        key:'rtPick',
        align: "right"
  },{
        title:Util.L('SOStatusPICKING'),
        width:100,
        key:'picking',
        align: "right"
  },{
        title:Util.L('SOStatusPICKED'),
        width:100,
        key:'picked',
        align: "right"
  },{
        title:Util.L('SOStatusPACKING'),
        width:100,
        key:'packing',
        align: "right"
  },{
        title:Util.L('SOStatusPACKED'),
        width:100,
        key:'packed',
        align: "right"
  },{
        title:Util.L('SOStatusRT_SHIP'),
        width:100,
        key:'rtShip',
        align: "right"
  },{
      title:Util.L('SOStatusSHIPPED'),
      width:100,
      key:'shipped',
      align: "right"
}
]